if (typeof HorizontalSlider !== 'function') {
	class HorizontalSlider extends HTMLElement {
		constructor() {
			super();
			// Prevent reinitialization
			this.slickInitialized = false;
		}

		connectedCallback() {
			// Initialize slider only if it hasn't been initialized already
			if (!this.slickInitialized) {

				this.initSlider();
			}
		}

		initSlider() {
			// Get attributes for configuration
			const showArrows = this.getAttribute('show-arrows');
			const autoplay = this.getAttribute('autoplay');
			const arrowLeft = this.getAttribute('arrow-left');
			const arrowRight = this.getAttribute('arrow-right');

			const minimumSlidesMobile = 1;
			const minimumSlidesDesktop = 2;
			const slidesToShowMobile = parseFloat(this.getAttribute('slides-mobile'));
			const slidesToShowDesktop = parseFloat(this.getAttribute('slides-desktop'));

			// Get the number of slides
			const totalSlides = this.querySelectorAll('.horizontal-slider__item').length;

			// Ensure slidesToShow does not exceed the total number of slides
			const slidesToShowMobileAdjusted = Math.max(minimumSlidesMobile, Math.min(slidesToShowMobile, totalSlides));
			const slidesToShowDesktopAdjusted = Math.max(minimumSlidesDesktop, Math.min(slidesToShowDesktop, totalSlides));

			// Get the skeleton elements
			const skeletonElements = this.querySelectorAll('.horizontal-slider__item--skeleton');
			// Remove the skeleton elements once Slick has fully initialized
			skeletonElements.forEach((item) => item.remove());
			// Ensure skeletons are removed when Slick initializes
			$(this).on('init', () => {
				this.slickInitialized = true; // Set the flag to prevent reinitialization
			});

			// If Slick is already initialized, unslick it before reinitializing
			if ($(this).hasClass('slick-initialized')) {
				$(this).slick('unslick');
			}

			// Initialize Slick Carousel
			$(this).slick({
				dots: false,
				infinite: false,
				autoplay: autoplay === 'true',
				arrows: showArrows === 'true',
				lazyLoad: 'ondemand',
				prevArrow: `<button type="button" class="button slick-prev">${arrowLeft}</button>`,
				nextArrow: `<button type="button" class="button slick-next">${arrowRight}</button>`,
				slidesToShow: window.innerWidth < 768 ? slidesToShowMobileAdjusted : slidesToShowDesktopAdjusted,
				responsive: [
					{
						breakpoint: 480,
						settings: {slidesToShow: slidesToShowMobileAdjusted}
					},
					{
						breakpoint: 768,
						settings: {slidesToShow: 2.5}
					},
					{
						breakpoint: 1023,
						settings: {slidesToShow: 3.5}
					},
					{
						breakpoint: 1440,
						settings: {slidesToShow: slidesToShowDesktopAdjusted}
					}
				]
			});
		}
	}

	if (!customElements.get('horizontal-slider')) {
		// Define the custom element
		customElements.define('horizontal-slider', HorizontalSlider);
	}
}
